import { render, staticRenderFns } from "./MoreDataDialog.vue?vue&type=template&id=4ab50835&scoped=true&"
import script from "./MoreDataDialog.vue?vue&type=script&lang=js&"
export * from "./MoreDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreDataDialog.vue?vue&type=style&index=0&id=4ab50835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab50835",
  null
  
)

export default component.exports